import React from "react";
import EntryRequirementVaccine from "./EntryRequirementVaccine";
import AdvisedVaccine from "./AdvisedVaccine";
import RecommendedVaccine from "./RecommendedVaccine";
import { motion } from "framer-motion";
import { Textarea } from "@mui/joy";
import CustomAction from "../../../../controls/CustomAction";

export default function VaccineSelection({
  mainColor,
  tripCountries,
  tripSelections,
  setTripSelections,
  handleNextStepPC,
  countryName,
  countryCode,
}) {
  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      exit={{ y: 50, opacity: 0 }}
      className="bf-content-wrapper pc-vaccine-selection"
    >
      <div className="bf-content-header">
        <h2 className="bf-title" style={{ color: mainColor }}>
          Select Products
        </h2>
        <p className="bf-subtitle">
          Choose which vaccines you think you would like
        </p>
      </div>
      <div className="bf-content-body">
        <EntryRequirementVaccine
          mainColor={mainColor}
          tripCountries={tripCountries}
        />
        <AdvisedVaccine mainColor={mainColor} tripCountries={tripCountries} />
        <RecommendedVaccine
          mainColor={mainColor}
          tripCountries={tripCountries}
        />

        <div className="pharmacy-comments-wrapper">
          <p className="title">Add any comments for Pharmacy</p>
          <Textarea
            placeholder="You can write your comments here..."
            className="pharmacy-comments-textarea"
            minRows={2}
            onChange={(e) => {}}
          />
        </div>

        <CustomAction mainColor={mainColor} text={"Continue"} action={handleNextStepPC} />
      </div>
    </motion.div>
  );
}
